import * as Tone from "tone"
let inst = {};
let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]

let samples = [{
    'A2': 'scale-A2.[mp3|ogg]',
    'A3': 'scale-A3.[mp3|ogg]',
    'C3': 'scale-C3.[mp3|ogg]',
    'C4': 'scale-C4.[mp3|ogg]',
    'D3': 'scale-C3.[mp3|ogg]',
    'D4': 'scale-D4.[mp3|ogg]',
    'E3': 'scale-E3.[mp3|ogg]',
    'E4': 'scale-E4.[mp3|ogg]',
    'G2': 'scale-G2.[mp3|ogg]',
    'G3': 'scale-G3.[mp3|ogg]',
}, {
    'attack': 0.001,
    'release': 0.3,
    'baseUrl': './teropa/'
}]


let delayL = new Tone.PingPongDelay("32n", 0.79)
let delayR = new Tone.PingPongDelay("16n", 0.92)

delayL.wet.value = 0.3;
delayR.wet.value = 0.3;
let meterL = new Tone.Meter();
let meterR = new Tone.Meter();
let defaultFreq = 50
let filterL = new Tone.Filter(defaultFreq, "highpass", -24);
let filterR = new Tone.Filter(defaultFreq, "highpass", -24);

let pannerL1 = new Tone.Panner(-0.0).toDestination()
let pannerL2 = new Tone.Panner(-1.0).toDestination()
let pannerL3 = new Tone.Panner(-0.2).toDestination()
let pannerR1 = new Tone.Panner(0.9).toDestination()
let pannerR2 = new Tone.Panner(0.5).toDestination()
let pannerR3 = new Tone.Panner(0.2).toDestination()
let pannerR4 = new Tone.Panner(0.9).toDestination()
let synthL = new Tone.Sampler(...samples)
let synthR = new Tone.Sampler(...samples)
synthL.volume.value = -18
synthR.volume.value = -18
synthL.connect(delayL)
synthR.connect(delayR)

delayL.connect(filterL)
delayR.connect(filterR)
filterL.connect(pannerL1)
filterL.connect(pannerL2)
filterL.connect(pannerL3)
filterR.connect(pannerR1)
filterR.connect(pannerR2)
filterR.connect(pannerR3)

delayL.connect(meterL)
delayR.connect(meterR)

Tone.Transport.bpm.value = 60;

function fmDrone(notes, playSeconds, tailSeconds) {
    let reverb = new Tone.Reverb({ decay: playSeconds / 4, wet: 0.8 });
    reverb.generate(); // Risky not to wait but ¯\_(ツ)_/¯
    let cho = new Tone.Chorus({ frequency: 0.33, depth: 0.7, wet: 0.85 })
    let del = new Tone.FeedbackDelay({
        delayTime: playSeconds / 16,
        feedback: 0.33,
        wet: 0.66
    })
    let synth = new Tone.PolySynth(Tone.FMSynth, {
        harmonicity: 0.5,
        modulationIndex: 1,
        oscillator: {
            type: "sine"
        },
        envelope: {
            attack: playSeconds / 4,
            sustain: 1,
            release: tailSeconds - 1,
            attackCurve: "linear",
            releaseCurve: "linear"
        },
        modulation: { type: "sine" },
        modulationEnvelope: {
            attack: playSeconds * 2,
            sustain: 1,
            release: tailSeconds,
            releaseCurve: "linear"
        },
        volume: -30
    }).chain(
        cho,
        del,
        reverb
    ).toDestination()

    synth.triggerAttackRelease(notes, playSeconds);
}

function fmBells(notes, playSeconds, tailSeconds) {
    let delay = new Tone.FeedbackDelay({
        delayTime: playSeconds / 8,
        feedback: 0.88,
        wet: 0.66
    });

    let flanger = new Tone.FeedbackDelay({
        delayTime: 0.005,
        feedback: 0.1,
        wet: 0.33
    });
    new Tone.LFO(1, 0.003, 0.007).start().connect(flanger.delayTime);

    let reverb = new Tone.Reverb({ decay: playSeconds / 4, wet: 0.8 });
    reverb.generate(); // Risky not to wait but ¯\_(ツ)_/¯

    let synth = new Tone.PolySynth(Tone.FMSynth, {
        harmonicity: 1.4,
        modulationIndex: 1,
        oscillator: {
            type: "sine"
        },
        envelope: {
            attack: 0.01,
            decay: 0.3,
            sustain: 0.6,
            release: tailSeconds - 1
        },
        modulation: { type: "triangle" },
        modulationEnvelope: {
            attack: 0.01,
            decay: 0.3,
            sustain: 0.6,
            release: tailSeconds
        },
        volume: -30
    }).chain(
        delay,
        flanger,
        reverb
    ).toDestination()
    synth.triggerAttackRelease(notes, playSeconds);
}

function bounceChord(notes, synthFn, playDuration, tailDuration) {
    let playSeconds = Tone.Time(playDuration).toSeconds();
    let tailSeconds = Tone.Time(tailDuration).toSeconds();
    return Tone.Offline(
        () => synthFn(notes, playSeconds, tailSeconds),
        playSeconds + tailSeconds
    );
}

function play() {
    Promise.all([
        bounceChord(["A#6", "F7", "A#7", "D#8", "F8"], fmDrone, 3, 3),
        bounceChord(["D#5", "A#5", "C6", "G6", "A#6", "C9"], fmDrone, 3, 3),
        bounceChord(["F6", "C6", "D#7", "A#7", "C8"], fmDrone, 3, 3),
        bounceChord(["A#5", "D#6", "G6", "C7", "D#7", "G8"], fmDrone, 3, 3),
        bounceChord(["A#6", "F7", "A#7", "D#8", "F8"], fmBells, 3, 3),
        bounceChord(["D#5", "A#5", "C6", "G6", "A#6", "C9"], fmBells, 3, 3),
        bounceChord(["F6", "C6", "D#7", "A#7", "C8"], fmBells, 3, 3),
        bounceChord(["A#5", "D#6", "G6", "C7", "D#7", "G8"], fmBells, 3, 3)
    ]).then(buffers => {
        console.log(buffers)
        let droneBuffer = buffers[0];
        let bellBuffer = buffers[4];
        console.log('bellä', bellBuffer)
        inst.drone = new Tone.ToneBufferSource({ url: droneBuffer, playbackRate: 0.125 })
            .toDestination()
        inst.bell = new Tone.ToneBufferSource({ url: bellBuffer, playbackRate: 0.125 })
            .toDestination()
            console.log(inst.bell)
        //Tone.Transport.scheduleOnce(next, "+" + getRand[6, 8]);

    });
    Tone.Transport.start();
}

inst = {
    delayL,
    delayR,
    filterL,
    filterR,
    synthL,
    synthR,
    meterL,
    meterR,
    defaultFreq,
    play,
    ready: 0,
    drone: undefined,
    bell: undefined
}
export default inst
